import navigation from "./navigation";
import locales from "./locales";
import currency from "./currencies";
export default {
  // product display information
  product: {
    name: "Lux Vuetify3",
    version: "1.0.0",
  },

  navigation,
  locales,
  currency,
};
